import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`With `}<a parentName="p" {...{
        "href": "/graphos/enterprise/"
      }}>{`GraphOS Enterprise`}</a>{`, you can enhance your supergraph's security by maintaining a `}<strong parentName="p">{`persisted query list`}</strong>{` (`}<strong parentName="p">{`PQL`}</strong>{`) for your supergraph's self-hosted router. To create and update the PQL, first-party apps register trusted operations to the PQL at `}<em parentName="p">{`build time`}</em>{`.`}</p>
    <p><div parentName="p" {...{
        "className": "mermaid"
      }}><svg parentName="div" {...{
          "aria-role-description": ["flowchart-v2"],
          "role": "graphics-document document",
          "viewBox": "-8 -8 502.421875 288",
          "style": {
            "maxWidth": "502.421875px"
          },
          "xmlns": "http://www.w3.org/2000/svg",
          "width": "100%",
          "id": "mermaid-0"
        }}><style parentName="svg">{`#mermaid-0{font-family:arial,sans-serif;font-size:16px;fill:#333;}#mermaid-0 .error-icon{fill:#552222;}#mermaid-0 .error-text{fill:#552222;stroke:#552222;}#mermaid-0 .edge-thickness-normal{stroke-width:2px;}#mermaid-0 .edge-thickness-thick{stroke-width:3.5px;}#mermaid-0 .edge-pattern-solid{stroke-dasharray:0;}#mermaid-0 .edge-pattern-dashed{stroke-dasharray:3;}#mermaid-0 .edge-pattern-dotted{stroke-dasharray:2;}#mermaid-0 .marker{fill:#333333;stroke:#333333;}#mermaid-0 .marker.cross{stroke:#333333;}#mermaid-0 svg{font-family:arial,sans-serif;font-size:16px;}#mermaid-0 .label{font-family:arial,sans-serif;color:#333;}#mermaid-0 .cluster-label text{fill:#333;}#mermaid-0 .cluster-label span,#mermaid-0 p{color:#333;}#mermaid-0 .label text,#mermaid-0 span,#mermaid-0 p{fill:#333;color:#333;}#mermaid-0 .node rect,#mermaid-0 .node circle,#mermaid-0 .node ellipse,#mermaid-0 .node polygon,#mermaid-0 .node path{fill:#ECECFF;stroke:#9370DB;stroke-width:1px;}#mermaid-0 .flowchart-label text{text-anchor:middle;}#mermaid-0 .node .label{text-align:center;}#mermaid-0 .node.clickable{cursor:pointer;}#mermaid-0 .arrowheadPath{fill:#333333;}#mermaid-0 .edgePath .path{stroke:#333333;stroke-width:2.0px;}#mermaid-0 .flowchart-link{stroke:#333333;fill:none;}#mermaid-0 .edgeLabel{background-color:#e8e8e8;text-align:center;}#mermaid-0 .edgeLabel rect{opacity:0.5;background-color:#e8e8e8;fill:#e8e8e8;}#mermaid-0 .labelBkg{background-color:rgba(232, 232, 232, 0.5);}#mermaid-0 .cluster rect{fill:#ffffde;stroke:#aaaa33;stroke-width:1px;}#mermaid-0 .cluster text{fill:#333;}#mermaid-0 .cluster span,#mermaid-0 p{color:#333;}#mermaid-0 div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:arial,sans-serif;font-size:12px;background:hsl(80, 100%, 96.2745098039%);border:1px solid #aaaa33;border-radius:2px;pointer-events:none;z-index:100;}#mermaid-0 .flowchartTitleText{text-anchor:middle;font-size:18px;fill:#333;}#mermaid-0 :root{--mermaid-font-family:arial,sans-serif;}`}</style><g parentName="svg"><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "12",
              "markerWidth": "12",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "6",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-pointEnd"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 0 0 L 10 5 L 0 10 z"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "12",
              "markerWidth": "12",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "4.5",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-pointStart"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 0 5 L 10 10 L 10 0 z"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "11",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-circleEnd"
            }}><circle parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "r": "5",
                "cy": "5",
                "cx": "5"
              }}></circle></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "-1",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-circleStart"
            }}><circle parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "r": "5",
                "cy": "5",
                "cx": "5"
              }}></circle></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5.2",
              "refX": "12",
              "viewBox": "0 0 11 11",
              "className": "marker cross flowchart",
              "id": "mermaid-0_flowchart-crossEnd"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "2",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 1,1 l 9,9 M 10,1 l -9,9"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5.2",
              "refX": "-1",
              "viewBox": "0 0 11 11",
              "className": "marker cross flowchart",
              "id": "mermaid-0_flowchart-crossStart"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "2",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 1,1 l 9,9 M 10,1 l -9,9"
              }}></path></marker><g parentName="g" {...{
              "className": "root"
            }}><g parentName="g" {...{
                "className": "clusters"
              }}><g parentName="g" {...{
                  "id": "Apps",
                  "className": "cluster default flowchart-label"
                }}><rect parentName="g" {...{
                    "height": "272",
                    "width": "175.890625",
                    "y": "0",
                    "x": "0",
                    "ry": "0",
                    "rx": "0",
                    "style": {}
                  }}></rect><g parentName="g" {...{
                    "transform": "translate(25.3125, 0)",
                    "className": "cluster-label"
                  }}><foreignObject parentName="g" {...{
                      "height": "19",
                      "width": "125.265625"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "nodeLabel"
                        }}>{`First-party apps`}</span></div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "edgePaths"
              }}><path parentName="g" {...{
                  "markerEnd": "url(#mermaid-0_flowchart-pointEnd)",
                  "style": {
                    "fill": "none"
                  },
                  "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-webClient LE-pql",
                  "id": "L-webClient-pql-0",
                  "d": "M137.406,52L143.82,52C150.234,52,163.063,52,185.964,52C208.865,52,241.839,52,275.346,61.245C308.854,70.49,342.896,88.98,359.917,98.225L376.938,107.47"
                }}></path><path parentName="g" {...{
                  "markerEnd": "url(#mermaid-0_flowchart-pointEnd)",
                  "style": {
                    "fill": "none"
                  },
                  "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-androidClient LE-pql",
                  "id": "L-androidClient-pql-0",
                  "d": "M150.891,136L155.057,136C159.224,136,167.557,136,188.211,136C208.865,136,241.839,136,274.013,136.079C306.186,136.158,337.56,136.316,353.247,136.394L368.934,136.473"
                }}></path><path parentName="g" {...{
                  "markerEnd": "url(#mermaid-0_flowchart-pointEnd)",
                  "style": {
                    "fill": "none"
                  },
                  "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-iosClient LE-pql",
                  "id": "L-iosClient-pql-0",
                  "d": "M133.563,220L140.617,220C147.672,220,161.781,220,185.323,220C208.865,220,241.839,220,275.343,210.916C308.848,201.832,342.884,183.664,359.902,174.58L376.92,165.496"
                }}></path></g><g parentName="g" {...{
                "className": "edgeLabels"
              }}><g parentName="g" {...{
                  "className": "edgeLabel"
                }}><g parentName="g" {...{
                    "transform": "translate(0, 0)",
                    "className": "label"
                  }}><foreignObject parentName="g" {...{
                      "height": "0",
                      "width": "0"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "edgeLabel"
                        }}></span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(274.8125, 136)",
                  "className": "edgeLabel"
                }}><g parentName="g" {...{
                    "transform": "translate(-73.921875, -19)",
                    "className": "label"
                  }}><foreignObject parentName="g" {...{
                      "height": "38",
                      "width": "147.84375"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "edgeLabel"
                        }}>{`Register `}<br parentName="span"></br>{` trusted operations`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "className": "edgeLabel"
                }}><g parentName="g" {...{
                    "transform": "translate(0, 0)",
                    "className": "label"
                  }}><foreignObject parentName="g" {...{
                      "height": "0",
                      "width": "0"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "edgeLabel"
                        }}></span></div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "nodes"
              }}><g parentName="g" {...{
                  "transform": "translate(87.9453125, 52)",
                  "id": "flowchart-webClient-0",
                  "className": "node default default flowchart-label"
                }}><rect parentName="g" {...{
                    "height": "34",
                    "width": "98.921875",
                    "y": "-17",
                    "x": "-49.4609375",
                    "ry": "5",
                    "rx": "5",
                    "style": {},
                    "className": "basic label-container"
                  }}></rect><g parentName="g" {...{
                    "transform": "translate(-41.9609375, -9.5)",
                    "style": {},
                    "className": "label"
                  }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                      "height": "19",
                      "width": "83.921875"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "nodeLabel"
                        }}>{`Web client`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(87.9453125, 136)",
                  "id": "flowchart-androidClient-1",
                  "className": "node default default flowchart-label"
                }}><rect parentName="g" {...{
                    "height": "34",
                    "width": "125.890625",
                    "y": "-17",
                    "x": "-62.9453125",
                    "ry": "5",
                    "rx": "5",
                    "style": {},
                    "className": "basic label-container"
                  }}></rect><g parentName="g" {...{
                    "transform": "translate(-55.4453125, -9.5)",
                    "style": {},
                    "className": "label"
                  }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                      "height": "19",
                      "width": "110.890625"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "nodeLabel"
                        }}>{`Android client`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(87.9453125, 220)",
                  "id": "flowchart-iosClient-2",
                  "className": "node default default flowchart-label"
                }}><rect parentName="g" {...{
                    "height": "34",
                    "width": "91.234375",
                    "y": "-17",
                    "x": "-45.6171875",
                    "ry": "5",
                    "rx": "5",
                    "style": {},
                    "className": "basic label-container"
                  }}></rect><g parentName="g" {...{
                    "transform": "translate(-38.1171875, -9.5)",
                    "style": {},
                    "className": "label"
                  }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                      "height": "19",
                      "width": "76.234375"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "nodeLabel"
                        }}>{`iOS client`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(430.078125, 136)",
                  "id": "flowchart-pql-3",
                  "className": "node default default flowchart-label"
                }}><polygon parentName="g" {...{
                    "style": {},
                    "transform": "translate(-48.34375,26.5)",
                    "className": "label-container",
                    "points": "0,0 96.6875,0 96.6875,-53 0,-53 0,0 -8,0 104.6875,0 104.6875,-53 -8,-53 -8,0"
                  }}></polygon><g parentName="g" {...{
                    "transform": "translate(-40.84375, -19)",
                    "style": {},
                    "className": "label"
                  }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                      "height": "38",
                      "width": "81.6875"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "nodeLabel"
                        }}>{`Persisted`}<br parentName="span"></br>{`Query List`}</span></div></foreignObject></g></g></g></g></g></svg></div></p>
    <blockquote>
      <p parentName="blockquote">{`Clients can register any kind of operation to a PQL, including queries, mutations, and subscriptions.`}</p>
    </blockquote>
    <p>{`At `}<em parentName="p">{`runtime`}</em>{`, the `}<a parentName="p" {...{
        "href": "/router/"
      }}>{`Apollo Router`}</a>{` checks incoming requests against the PQL, which can act as operation safelist, depending on your `}<a parentName="p" {...{
        "href": "#2-router-configuration"
      }}>{`router configuration`}</a>{`.`}</p>
    <p><div parentName="p" {...{
        "className": "mermaid"
      }}><svg parentName="div" {...{
          "aria-role-description": ["flowchart-v2"],
          "role": "graphics-document document",
          "viewBox": "-7.5 -8 986.203125 450.5",
          "style": {
            "maxWidth": "986.203125px"
          },
          "xmlns": "http://www.w3.org/2000/svg",
          "width": "100%",
          "id": "mermaid-1"
        }}><style parentName="svg">{`#mermaid-1{font-family:arial,sans-serif;font-size:16px;fill:#333;}#mermaid-1 .error-icon{fill:#552222;}#mermaid-1 .error-text{fill:#552222;stroke:#552222;}#mermaid-1 .edge-thickness-normal{stroke-width:2px;}#mermaid-1 .edge-thickness-thick{stroke-width:3.5px;}#mermaid-1 .edge-pattern-solid{stroke-dasharray:0;}#mermaid-1 .edge-pattern-dashed{stroke-dasharray:3;}#mermaid-1 .edge-pattern-dotted{stroke-dasharray:2;}#mermaid-1 .marker{fill:#333333;stroke:#333333;}#mermaid-1 .marker.cross{stroke:#333333;}#mermaid-1 svg{font-family:arial,sans-serif;font-size:16px;}#mermaid-1 .label{font-family:arial,sans-serif;color:#333;}#mermaid-1 .cluster-label text{fill:#333;}#mermaid-1 .cluster-label span,#mermaid-1 p{color:#333;}#mermaid-1 .label text,#mermaid-1 span,#mermaid-1 p{fill:#333;color:#333;}#mermaid-1 .node rect,#mermaid-1 .node circle,#mermaid-1 .node ellipse,#mermaid-1 .node polygon,#mermaid-1 .node path{fill:#ECECFF;stroke:#9370DB;stroke-width:1px;}#mermaid-1 .flowchart-label text{text-anchor:middle;}#mermaid-1 .node .label{text-align:center;}#mermaid-1 .node.clickable{cursor:pointer;}#mermaid-1 .arrowheadPath{fill:#333333;}#mermaid-1 .edgePath .path{stroke:#333333;stroke-width:2.0px;}#mermaid-1 .flowchart-link{stroke:#333333;fill:none;}#mermaid-1 .edgeLabel{background-color:#e8e8e8;text-align:center;}#mermaid-1 .edgeLabel rect{opacity:0.5;background-color:#e8e8e8;fill:#e8e8e8;}#mermaid-1 .labelBkg{background-color:rgba(232, 232, 232, 0.5);}#mermaid-1 .cluster rect{fill:#ffffde;stroke:#aaaa33;stroke-width:1px;}#mermaid-1 .cluster text{fill:#333;}#mermaid-1 .cluster span,#mermaid-1 p{color:#333;}#mermaid-1 div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:arial,sans-serif;font-size:12px;background:hsl(80, 100%, 96.2745098039%);border:1px solid #aaaa33;border-radius:2px;pointer-events:none;z-index:100;}#mermaid-1 .flowchartTitleText{text-anchor:middle;font-size:18px;fill:#333;}#mermaid-1 :root{--mermaid-font-family:arial,sans-serif;}`}</style><g parentName="svg"><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "12",
              "markerWidth": "12",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "6",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-1_flowchart-pointEnd"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 0 0 L 10 5 L 0 10 z"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "12",
              "markerWidth": "12",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "4.5",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-1_flowchart-pointStart"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 0 5 L 10 10 L 10 0 z"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "11",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-1_flowchart-circleEnd"
            }}><circle parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "r": "5",
                "cy": "5",
                "cx": "5"
              }}></circle></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "-1",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-1_flowchart-circleStart"
            }}><circle parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "r": "5",
                "cy": "5",
                "cx": "5"
              }}></circle></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5.2",
              "refX": "12",
              "viewBox": "0 0 11 11",
              "className": "marker cross flowchart",
              "id": "mermaid-1_flowchart-crossEnd"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "2",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 1,1 l 9,9 M 10,1 l -9,9"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5.2",
              "refX": "-1",
              "viewBox": "0 0 11 11",
              "className": "marker cross flowchart",
              "id": "mermaid-1_flowchart-crossStart"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "2",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 1,1 l 9,9 M 10,1 l -9,9"
              }}></path></marker><g parentName="g" {...{
              "className": "root"
            }}><g parentName="g" {...{
                "className": "clusters"
              }}><g parentName="g" {...{
                  "id": "Supergraph",
                  "className": "cluster default flowchart-label"
                }}><rect parentName="g" {...{
                    "height": "404",
                    "width": "641.609375",
                    "y": "30.5",
                    "x": "329.09375",
                    "ry": "0",
                    "rx": "0",
                    "style": {}
                  }}></rect><g parentName="g" {...{
                    "transform": "translate(603.1796875, 30.5)",
                    "className": "cluster-label"
                  }}><foreignObject parentName="g" {...{
                      "height": "19",
                      "width": "93.4375"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "nodeLabel"
                        }}>{`Supergraph`}</span></div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "edgePaths"
              }}><path parentName="g" {...{
                  "markerEnd": "url(#mermaid-1_flowchart-pointEnd)",
                  "style": {
                    "fill": "none"
                  },
                  "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Apps LE-Router",
                  "id": "L-Apps-Router-0",
                  "d": "M175.891,136L188.658,136C201.424,136,226.958,136,252.492,136C278.026,136,303.56,136,319.828,139.054C336.096,142.109,343.098,148.217,346.599,151.272L350.1,154.326"
                }}></path><path parentName="g" {...{
                  "markerEnd": "url(#mermaid-1_flowchart-pointEnd)",
                  "style": {
                    "fill": "none"
                  },
                  "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-bad LE-Router",
                  "id": "L-bad-Router-0",
                  "d": "M134.078,339L153.814,339C173.549,339,213.021,339,245.523,339C278.026,339,303.56,339,319.828,335.946C336.096,332.891,343.098,326.783,346.599,323.728L350.1,320.674"
                }}></path><path parentName="g" {...{
                  "markerEnd": "url(#mermaid-1_flowchart-pointEnd)",
                  "style": {
                    "fill": "none"
                  },
                  "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Router LE-Subgraphs",
                  "id": "L-Router-Subgraphs-0",
                  "d": "M536.781,193.61L556.938,183.925C577.094,174.24,617.406,154.87,656.928,154.846C696.45,154.822,735.182,174.144,754.548,183.805L773.914,193.466"
                }}></path><path parentName="g" {...{
                  "style": {
                    "fill": "none",
                    "strokeWidth": "2px",
                    "strokeDasharray": "3"
                  },
                  "className": "edge-thickness-normal edge-pattern-dotted flowchart-link LS-Router LE-Subgraphs",
                  "id": "L-Router-Subgraphs-1",
                  "d": "M536.781,277.087L556.938,285.823C577.094,294.558,617.406,312.029,657.719,311.695C698.031,311.361,738.344,293.222,758.5,284.152L778.656,275.083"
                }}></path></g><g parentName="g" {...{
                "className": "edgeLabels"
              }}><g parentName="g" {...{
                  "transform": "translate(252.4921875, 136)",
                  "className": "edgeLabel"
                }}><g parentName="g" {...{
                    "transform": "translate(-42.765625, -19)",
                    "className": "label"
                  }}><foreignObject parentName="g" {...{
                      "height": "38",
                      "width": "85.53125"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "edgeLabel"
                        }}>{`Registered`}<br parentName="span"></br>{` operations`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(252.4921875, 339)",
                  "className": "edgeLabel"
                }}><g parentName="g" {...{
                    "transform": "translate(-51.6015625, -19)",
                    "className": "label"
                  }}><foreignObject parentName="g" {...{
                      "height": "38",
                      "width": "103.203125"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "edgeLabel"
                        }}>{`Unregistered`}<br parentName="span"></br>{` operations`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(657.71875, 135.5)",
                  "className": "edgeLabel"
                }}><g parentName="g" {...{
                    "transform": "translate(-85.796875, -19)",
                    "className": "label"
                  }}><foreignObject parentName="g" {...{
                      "height": "38",
                      "width": "171.59375"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "edgeLabel"
                        }}>{`✅ Router executes `}<br parentName="span"></br>{`registered operations`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(657.71875, 329.5)",
                  "className": "edgeLabel"
                }}><g parentName="g" {...{
                    "transform": "translate(-95.9375, -19)",
                    "className": "label"
                  }}><foreignObject parentName="g" {...{
                      "height": "38",
                      "width": "191.875"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "edgeLabel"
                        }}>{`❌ Router blocks `}<br parentName="span"></br>{`unregistered operations`}</span></div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "nodes"
              }}><g parentName="g" {...{
                  "transform": "translate(346.59375, 126.5)",
                  "className": "root"
                }}><g parentName="g" {...{
                    "className": "clusters"
                  }}><g parentName="g" {...{
                      "id": "Router",
                      "className": "cluster default flowchart-label"
                    }}><rect parentName="g" {...{
                        "height": "206",
                        "width": "182.6875",
                        "y": "8",
                        "x": "8",
                        "ry": "0",
                        "rx": "0",
                        "style": {}
                      }}></rect><g parentName="g" {...{
                        "transform": "translate(45.5, 8)",
                        "className": "cluster-label"
                      }}><foreignObject parentName="g" {...{
                          "height": "19",
                          "width": "107.6875"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Apollo Router`}</span></div></foreignObject></g></g></g><g parentName="g" {...{
                    "className": "edgePaths"
                  }}><path parentName="g" {...{
                      "markerEnd": "url(#mermaid-1_flowchart-pointEnd)",
                      "markerStart": "url(#mermaid-1_flowchart-pointStart)",
                      "style": {
                        "fill": "none"
                      },
                      "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-router LE-pql",
                      "id": "L-router-pql-0",
                      "d": "M99.344,91.3L99.344,94.583C99.344,97.867,99.344,104.433,99.41,111.084C99.476,117.734,99.608,124.467,99.674,127.834L99.74,131.201"
                    }}></path></g><g parentName="g" {...{
                    "className": "edgeLabels"
                  }}><g parentName="g" {...{
                      "className": "edgeLabel"
                    }}><g parentName="g" {...{
                        "transform": "translate(0, 0)",
                        "className": "label"
                      }}><foreignObject parentName="g" {...{
                          "height": "0",
                          "width": "0"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "edgeLabel"
                            }}></span></div></foreignObject></g></g></g><g parentName="g" {...{
                    "className": "nodes"
                  }}><g parentName="g" {...{
                      "transform": "translate(99.34375, 59.5)",
                      "id": "flowchart-router-15",
                      "className": "node default default flowchart-label"
                    }}><rect parentName="g" {...{
                        "height": "53",
                        "width": "81.28125",
                        "y": "-26.5",
                        "x": "-40.640625",
                        "ry": "26.5",
                        "rx": "26.5",
                        "style": {}
                      }}></rect><g parentName="g" {...{
                        "transform": "translate(-26.515625, -19)",
                        "style": {},
                        "className": "label"
                      }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                          "height": "38",
                          "width": "53.03125"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Graph`}<br parentName="span"></br>{`Router`}</span></div></foreignObject></g></g><g parentName="g" {...{
                      "transform": "translate(99.34375, 162.5)",
                      "id": "flowchart-pql-16",
                      "className": "node default default flowchart-label"
                    }}><polygon parentName="g" {...{
                        "style": {},
                        "transform": "translate(-48.34375,26.5)",
                        "className": "label-container",
                        "points": "0,0 96.6875,0 96.6875,-53 0,-53 0,0 -8,0 104.6875,0 104.6875,-53 -8,-53 -8,0"
                      }}></polygon><g parentName="g" {...{
                        "transform": "translate(-40.84375, -19)",
                        "style": {},
                        "className": "label"
                      }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                          "height": "38",
                          "width": "81.6875"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Persisted`}<br parentName="span"></br>{`Query List`}</span></div></foreignObject></g></g></g></g><g parentName="g" {...{
                  "transform": "translate(771.15625, 93.5)",
                  "className": "root"
                }}><g parentName="g" {...{
                    "className": "clusters"
                  }}><g parentName="g" {...{
                      "id": "Subgraphs",
                      "className": "cluster default flowchart-label"
                    }}><rect parentName="g" {...{
                        "height": "272",
                        "width": "167.046875",
                        "y": "8",
                        "x": "8",
                        "ry": "0",
                        "rx": "0",
                        "style": {}
                      }}></rect><g parentName="g" {...{
                        "transform": "translate(48.7109375, 8)",
                        "className": "cluster-label"
                      }}><foreignObject parentName="g" {...{
                          "height": "19",
                          "width": "85.625"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Subgraphs`}</span></div></foreignObject></g></g></g><g parentName="g" {...{
                    "className": "edgePaths"
                  }}></g><g parentName="g" {...{
                    "className": "edgeLabels"
                  }}></g><g parentName="g" {...{
                    "className": "nodes"
                  }}><g parentName="g" {...{
                      "transform": "translate(91.5234375, 60)",
                      "id": "flowchart-api1-19",
                      "className": "node default default flowchart-label"
                    }}><rect parentName="g" {...{
                        "height": "34",
                        "width": "116.828125",
                        "y": "-17",
                        "x": "-58.4140625",
                        "ry": "17",
                        "rx": "17",
                        "style": {}
                      }}></rect><g parentName="g" {...{
                        "transform": "translate(-46.6640625, -9.5)",
                        "style": {},
                        "className": "label"
                      }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                          "height": "19",
                          "width": "93.328125"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Subgraph A`}</span></div></foreignObject></g></g><g parentName="g" {...{
                      "transform": "translate(91.5234375, 144)",
                      "id": "flowchart-api2-20",
                      "className": "node default default flowchart-label"
                    }}><rect parentName="g" {...{
                        "height": "34",
                        "width": "116.859375",
                        "y": "-17",
                        "x": "-58.4296875",
                        "ry": "17",
                        "rx": "17",
                        "style": {}
                      }}></rect><g parentName="g" {...{
                        "transform": "translate(-46.6796875, -9.5)",
                        "style": {},
                        "className": "label"
                      }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                          "height": "19",
                          "width": "93.359375"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Subgraph B`}</span></div></foreignObject></g></g><g parentName="g" {...{
                      "transform": "translate(91.5234375, 228)",
                      "id": "flowchart-api3-21",
                      "className": "node default default flowchart-label"
                    }}><rect parentName="g" {...{
                        "height": "34",
                        "width": "117.046875",
                        "y": "-17",
                        "x": "-58.5234375",
                        "ry": "17",
                        "rx": "17",
                        "style": {}
                      }}></rect><g parentName="g" {...{
                        "transform": "translate(-46.7734375, -9.5)",
                        "style": {},
                        "className": "label"
                      }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                          "height": "19",
                          "width": "93.546875"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Subgraph C`}</span></div></foreignObject></g></g></g></g><g parentName="g" {...{
                  "transform": "translate(-7.5, -8)",
                  "className": "root"
                }}><g parentName="g" {...{
                    "className": "clusters"
                  }}><g parentName="g" {...{
                      "id": "Apps",
                      "className": "cluster default flowchart-label"
                    }}><rect parentName="g" {...{
                        "height": "272",
                        "width": "175.890625",
                        "y": "8",
                        "x": "8",
                        "ry": "0",
                        "rx": "0",
                        "style": {}
                      }}></rect><g parentName="g" {...{
                        "transform": "translate(33.3125, 8)",
                        "className": "cluster-label"
                      }}><foreignObject parentName="g" {...{
                          "height": "19",
                          "width": "125.265625"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`First-party apps`}</span></div></foreignObject></g></g></g><g parentName="g" {...{
                    "className": "edgePaths"
                  }}></g><g parentName="g" {...{
                    "className": "edgeLabels"
                  }}></g><g parentName="g" {...{
                    "className": "nodes"
                  }}><g parentName="g" {...{
                      "transform": "translate(95.9453125, 60)",
                      "id": "flowchart-webClient-11",
                      "className": "node default default flowchart-label"
                    }}><rect parentName="g" {...{
                        "height": "34",
                        "width": "98.921875",
                        "y": "-17",
                        "x": "-49.4609375",
                        "ry": "5",
                        "rx": "5",
                        "style": {},
                        "className": "basic label-container"
                      }}></rect><g parentName="g" {...{
                        "transform": "translate(-41.9609375, -9.5)",
                        "style": {},
                        "className": "label"
                      }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                          "height": "19",
                          "width": "83.921875"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Web client`}</span></div></foreignObject></g></g><g parentName="g" {...{
                      "transform": "translate(95.9453125, 144)",
                      "id": "flowchart-androidClient-12",
                      "className": "node default default flowchart-label"
                    }}><rect parentName="g" {...{
                        "height": "34",
                        "width": "125.890625",
                        "y": "-17",
                        "x": "-62.9453125",
                        "ry": "5",
                        "rx": "5",
                        "style": {},
                        "className": "basic label-container"
                      }}></rect><g parentName="g" {...{
                        "transform": "translate(-55.4453125, -9.5)",
                        "style": {},
                        "className": "label"
                      }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                          "height": "19",
                          "width": "110.890625"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Android client`}</span></div></foreignObject></g></g><g parentName="g" {...{
                      "transform": "translate(95.9453125, 228)",
                      "id": "flowchart-iosClient-13",
                      "className": "node default default flowchart-label"
                    }}><rect parentName="g" {...{
                        "height": "34",
                        "width": "91.234375",
                        "y": "-17",
                        "x": "-45.6171875",
                        "ry": "5",
                        "rx": "5",
                        "style": {},
                        "className": "basic label-container"
                      }}></rect><g parentName="g" {...{
                        "transform": "translate(-38.1171875, -9.5)",
                        "style": {},
                        "className": "label"
                      }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                          "height": "19",
                          "width": "76.234375"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`iOS client`}</span></div></foreignObject></g></g></g></g><g parentName="g" {...{
                  "transform": "translate(87.9453125, 339)",
                  "id": "flowchart-bad-14",
                  "className": "node default secondary flowchart-label"
                }}><rect parentName="g" {...{
                    "height": "34",
                    "width": "92.265625",
                    "y": "-17",
                    "x": "-46.1328125",
                    "ry": "5",
                    "rx": "5",
                    "style": {},
                    "className": "basic label-container"
                  }}></rect><g parentName="g" {...{
                    "transform": "translate(-38.6328125, -9.5)",
                    "style": {},
                    "className": "label"
                  }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                      "height": "19",
                      "width": "77.265625"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "nodeLabel"
                        }}>{`Bad actor`}</span></div></foreignObject></g></g></g></g></g></svg></div></p>
    <p>{`Your router can use its persisted query list (PQL) to both `}<strong parentName="p">{`protect your supergraph`}</strong>{` and `}<strong parentName="p">{`speed up your clients' operations`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`When you enable `}<strong parentName="p">{`safelisting`}</strong>{`, your router rejects any incoming operations not registered in its PQL.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Client apps can execute an operation by providing its PQL-specified ID `}<em parentName="p">{`instead of`}</em>{` the entire operation string.`}</p>
        <ul parentName="li">
          <li parentName="ul">{`Requesting by ID can significantly reduce latency and bandwidth usage for very large operation strings.`}</li>
          <li parentName="ul">{`Your router can `}<em parentName="li">{`require`}</em>{` that clients provide operations by ID and `}<em parentName="li">{`reject`}</em>{` full operation strings—even operation strings present in the PQL.`}</li>
        </ul>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      